import { render, staticRenderFns } from "./Bugtracker.vue?vue&type=template&id=329647e6&"
import script from "./Bugtracker.vue?vue&type=script&lang=js&"
export * from "./Bugtracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports